import { render } from "./ComponenteDatosAnuales.vue?vue&type=template&id=551e5e85&scoped=true"
import script from "./ComponenteDatosAnuales.vue?vue&type=script&lang=js"
export * from "./ComponenteDatosAnuales.vue?vue&type=script&lang=js"

import "./ComponenteDatosAnuales.vue?vue&type=style&index=0&id=551e5e85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551e5e85"]])

export default __exports__